// removed by extract-text-webpack-plugin
module.exports = {"profile_image":"profile_image__2Z2gW"};


//////////////////
// WEBPACK FOOTER
// ./components/topbar/style.scss
// module id = Pa0y
// module chunks = 3